import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=619f6fff&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619f6fff')) {
      api.createRecord('619f6fff', component.options)
    } else {
      api.reload('619f6fff', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=619f6fff&", function () {
      api.rerender('619f6fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/pricehelp.vue"
export default component.exports